import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const StorefrontInlineBanner = ({ slide }) => {
  if (!slide?.image) return null;

  const content = (
    <>
      <img src={slide.image} alt={slide.altText || slide.subtitle || slide.title || "Store promotion"} />
      <span className="storefront-inline-banner-shade" />
      <span className="storefront-inline-banner-copy">
        {slide.title && <span className="storefront-inline-banner-eyebrow">{slide.title}</span>}
        {slide.subtitle && <strong>{slide.subtitle}</strong>}
        {slide.buttonText && (
          <span className="storefront-inline-banner-button">
            {slide.buttonText} <FiArrowRight aria-hidden="true" />
          </span>
        )}
      </span>
    </>
  );
  const destination = slide.link || "/shop";

  if (destination.startsWith("/") && !destination.startsWith("//")) {
    return (
      <Link className="storefront-inline-banner" to={destination}>
        {content}
      </Link>
    );
  }

  try {
    if (new URL(destination).protocol === "https:") {
      return (
        <a
          className="storefront-inline-banner"
          href={destination}
          target="_blank"
          rel="noopener noreferrer"
        >
          {content}
        </a>
      );
    }
  } catch (error) {
    return null;
  }

  return null;
};

export default StorefrontInlineBanner;
